var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.901 2.1135L17.263 0.477752C17.0939 0.308627 16.8715 0.223877 16.6495 0.223877C16.4275 0.223877 16.2055 0.308252 16.0364 0.477377L14.7261 1.78388L17.5907 4.64363L18.901 3.3375C19.2396 2.99925 19.2396 2.45063 18.901 2.1135Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22073 10.2735L9.08573 13.1336L16.9776 5.25638L14.1126 2.39625L6.22073 10.2735Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60235 10.8855L4.99073 14.355L8.46735 13.7453L5.60235 10.8855Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5224 15.9011H2.7201V5.09888H10.3435L12.2222 3.22388H2.05748C1.39035 3.22388 0.844727 3.7695 0.844727 4.43663V16.5638C0.844727 17.2309 1.39035 17.7765 2.05748 17.7765H14.1846C14.8517 17.7765 15.3974 17.2309 15.3974 16.5638V7.89338L13.5224 9.765V15.9011Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a7c981d6997368d2c0b70085566ff304.svg";
export { ForwardRef as ReactComponent };